import React from "react";

import { Container, Grid } from "@mui/material";
import GraphHeader from "../../graphs/GraphHeader";
import ImageGraph from "../../graphs/ImageGraph";

import { formatOutput } from "../../../utils/computation/analysis";

const OneSampleTTestResult = ({ test }) => {
  const { confidenceLevel, meanHypothesis } = test.inputs;
  return (
    <>
      <GraphHeader
        column={test.column}
        dateTime={test.dateTime}
        title={"1-Sample t"}
        analysisId={test.id}
        additionals={{
          confidenceLevel,
          meanHypothesis,
        }}
        graphs={test.graphs}
      />

      <Container
        style={{
          padding: "2px",
        }}
      >
        <Grid
          container
          spacing={{ xs: 2, md: 3 }}
          columns={{ xs: 4, sm: 8, md: 12 }}
          sx={{ p: 3 }}
        >
          <Grid xs={2} sm={3} md={3}>
            <h4>N</h4>
            <h2
              style={{
                color: "#777777",
                fontWeight: "normal",
              }}
            >
              {test["output"]["descriptiveAnalysis"]["arrayLength"] || ""}
            </h2>
          </Grid>
          <Grid xs={2} sm={3} md={3}>
            <h4>Mean</h4>
            <h2
              style={{
                color: "#777777",
                fontWeight: "normal",
              }}
            >
              {test["output"]["descriptiveAnalysis"]["mean"] &&
                formatOutput(test["output"]["descriptiveAnalysis"]["mean"][0])}
            </h2>
          </Grid>
          <Grid xs={2} sm={3} md={3}>
            <h4>StDev</h4>
            <h2
              style={{
                color: "#777777",
                fontWeight: "normal",
              }}
            >
              {formatOutput(
                test["output"]["descriptiveAnalysis"]["standardDeviation"][0]
              )}
            </h2>
          </Grid>
          <Grid xs={2} sm={3} md={3}>
            <h4>SE Mean</h4>
            <h2
              style={{
                color: "#777777",
                fontWeight: "normal",
              }}
            >
              {formatOutput(test["output"]["descriptiveAnalysis"]["statssem"])}
            </h2>
          </Grid>
          <Grid xs={12} sm={12} md={12} sx={{ mt: 2 }}>
            <h4>
              {test["inputs"]["confidenceLevel"] * 100}% Column {test["column"]}{" "}
              for u
            </h4>
            <h2
              style={{
                color: "#777777",
                fontWeight: "normal",
              }}
            >
              (
              {formatOutput(
                test["output"]["descriptiveAnalysis"]["sttinterval"][0]
              )}
              ,{" "}
              {formatOutput(
                test["output"]["descriptiveAnalysis"]["sttinterval"][1]
              )}
              )
            </h2>
            <span>
              Note: u is the population mean of Column {test["column"]}
            </span>
          </Grid>
          {test["hypothesisTest"] && (
            <>
              {" "}
              <Grid xs={2} sm={3} md={3} sx={{ mt: 2 }}>
                <h4>Null hypothesis</h4>
                <h3
                  style={{
                    color: "#777777",
                    fontWeight: "normal",
                  }}
                >
                  <p>
                    H<sub>0</sub> ={" "}
                    {formatOutput(test["inputs"]["meanHypothesis"])}
                  </p>
                </h3>
              </Grid>
              <Grid xs={2} sm={3} md={3} sx={{ mt: 2 }}>
                <h4>Alternative hypothesis</h4>
                <h3
                  style={{
                    color: "#777777",
                    fontWeight: "normal",
                  }}
                >
                  <p>
                    H<sub>1</sub> ≠{" "}
                    {formatOutput(test["inputs"]["meanHypothesis"])}
                  </p>
                </h3>
              </Grid>
              <Grid xs={2} sm={3} md={3} sx={{ mt: 2 }}>
                <h4>T-Value</h4>
                <h2
                  style={{
                    color: "#777777",
                    fontWeight: "normal",
                    whiteSpace: "pre-wrap",
                  }}
                >
                  {formatOutput(test["output"]["ttest"]["t_statistic"])}
                </h2>
              </Grid>
              <Grid xs={2} sm={3} md={3} sx={{ mt: 2 }}>
                <h4>P-Value</h4>
                <h2
                  style={{
                    color: "#777777",
                    fontWeight: "normal",
                  }}
                >
                  {formatOutput(test["output"]["ttest"]["p_value"])}
                </h2>
              </Grid>
            </>
          )}
        </Grid>

        {test.graphs.boxplot && (
          <ImageGraph
            url={test["boxPlotResult"]["boxplot"]}
            title="BoxPlot"
            column={test["column"]}
            percent={test["inputs"]["confidenceLevel"] * 100}
          />
        )}
        {test.graphs.histogram && (
          <ImageGraph
            url={test["histogramResult"]["histogram"]}
            title="Histogram"
            column={test["column"]}
            percent={test["inputs"]["confidenceLevel"] * 100}
          />
        )}

        <Grid item xs={12} sm={12} md={12}>
          <h4>{test?.output?.conclusion}</h4>
        </Grid>
      </Container>
    </>
  );
};

export default OneSampleTTestResult;
